import { useMemo } from 'react';
import * as React from 'react';

import { Ticket } from '@/modelTypes';

/**
 * 与えられたticketsの購入口数の合算を算出する
 */
const PurchasedCount: React.FC<{ tickets: Ticket[] }> = ({ tickets }) => {
  const count = useMemo(
    () =>
      tickets
        .filter(t => !t.isRemoved)
        .map(t => t.count)
        .reduce((sum, element) => sum + element, 0),
    [tickets],
  );

  return <span>{count.toLocaleString()}</span>;
};

export default PurchasedCount;
